import React from 'react';

const DeploymentButton = ({ selectedConfig, isDeploying, onDeploy }) => {
  return (
    <button
      className="btn btn-primary"
      style={{
        width: '100%',
        padding: '18px',
        fontSize: '1.2rem',
        marginBottom: '30px'
      }}
      disabled={!selectedConfig || isDeploying}
      onClick={onDeploy}
    >
      {isDeploying ? (
        <>
          <div className="spinner" />
          Deploying...
        </>
      ) : (
        'Deploy to Production'
      )}
    </button>
  );
};

export default DeploymentButton;